import { render, staticRenderFns } from "./BuyBoxUpcomingNew.vue?vue&type=template&id=250cb48b&scoped=true"
import script from "./BuyBoxUpcomingNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxUpcomingNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxUpcomingNew.vue?vue&type=style&index=0&id=250cb48b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250cb48b",
  null
  
)

export default component.exports